import { render, staticRenderFns } from "./UnloadingSipSettingsDoorphone.vue?vue&type=template&id=8567ff62"
import script from "./UnloadingSipSettingsDoorphone.vue?vue&type=script&lang=js"
export * from "./UnloadingSipSettingsDoorphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports